import { f as t } from "./function-apply.js";
import { t as r } from "./to-indexed-object.js";
import { t as a } from "./to-integer-or-infinity.js";
import { l as i } from "./length-of-array-like.js";
import { a as o } from "./array-method-is-strict.js";
var n = Math.min,
  s = [].lastIndexOf,
  e = !!s && 1 / [1].lastIndexOf(1, -0) < 0,
  f = o("lastIndexOf"),
  m = e || !f ? function (o) {
    if (e) return t(s, this, arguments) || 0;
    var f = r(this),
      m = i(f),
      l = m - 1;
    for (arguments.length > 1 && (l = n(l, a(arguments[1]))), l < 0 && (l = m + l); l >= 0; l--) if (l in f && f[l] === o) return l || 0;
    return -1;
  } : s;
export { m as a };